var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 1.33333C10.527 1.33333 12.7803 2.75333 13.8803 5C12.7803 7.24667 10.5337 8.66667 8.00033 8.66667C5.46699 8.66667 3.22033 7.24667 2.12033 5C3.22033 2.75333 5.47366 1.33333 8.00033 1.33333ZM8.00033 0C4.66699 0 1.82033 2.07333 0.666992 5C1.82033 7.92667 4.66699 10 8.00033 10C11.3337 10 14.1803 7.92667 15.3337 5C14.1803 2.07333 11.3337 0 8.00033 0ZM8.00033 3.33333C8.92033 3.33333 9.66699 4.08 9.66699 5C9.66699 5.92 8.92033 6.66667 8.00033 6.66667C7.08033 6.66667 6.33366 5.92 6.33366 5C6.33366 4.08 7.08033 3.33333 8.00033 3.33333ZM8.00033 2C6.34699 2 5.00033 3.34667 5.00033 5C5.00033 6.65333 6.34699 8 8.00033 8C9.65366 8 11.0003 6.65333 11.0003 5C11.0003 3.34667 9.65366 2 8.00033 2Z",
    fill: "#7185BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.6ea9f5b94976eff6824cae982e6987c8.svg";
export { ForwardRef as ReactComponent };